import React from "react";
import './customButton.style.scss';

const CustomButton = ({ background, label, onClick, textColor, icon, isSelected, toolTip }) => {
    // Determine dynamic classes based on props
    const buttonClasses = `custom-button ${isSelected ? "selected" : ""}`;

    return (
        <button
            title={toolTip}
            className={buttonClasses}
            onClick={onClick}
            style={{
                "--button-bg": background || "var(--primary)",
                "--text-color": textColor || "var(--white)",
            }}
        >
            {icon ? (
                <img
                    src={icon}
                    alt={label || "Icon"}
                    style={{
                        height: "24px", // Adjust the size of the icon
                        width: "24px",
                    }}
                />
            ) : (
                label
            )}
        </button>
    );
};

export default CustomButton;
